import React, { useEffect, useState } from 'react'
import { Icon } from '@iconify/react';
import { useAuth } from '../../context/AuthContext';
import config from '../../config';

const UnitCountOne = () => {
    const { auth } = useAuth();
    const [stats, setStats] = useState({
        total_users: 0,
        users_last_30: 0,
        total_subscriptions: 0,
        subscriptions_last_30: 0,
        total_free_users: 0,
        free_users_last_30: 0,
        total_income: 0,
        income_last_30: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await auth.fetch(`${config.API_BASE_URL}/api/payments/stats`);
                if (response.ok) {
                    const data = await response.json();
                    if (data.cards) {
                        setStats(data.cards);
                    }
                }
            } catch (error) {
                console.error('Failed to fetch stats:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, [auth]);

    if (loading) {
        return <div className="row gy-4"><div className="col-12">Loading stats...</div></div>;
    }

    return (
        <div className="row row-cols-xxxl-4 row-cols-lg-2 row-cols-1 gy-4">
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-1 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Users</p>
                                <h6 className="mb-0">{stats.total_users.toLocaleString()}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-primary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="gridicons:multiple-users"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                        <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                            <span className="d-inline-flex align-items-center gap-1 text-success-main">
                                <Icon icon="bxs:up-arrow" className="text-xs" /> +{stats.users_last_30.toLocaleString()}
                            </span>
                            Last 30 days users
                        </p>
                    </div>
                </div>
                {/* card end */}
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-2 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">
                                    Total Subscription
                                </p>
                                <h6 className="mb-0">{stats.total_subscriptions.toLocaleString()}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-primary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="fa-solid:award"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                        <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                            <span className="d-inline-flex align-items-center gap-1 text-success-main">
                                <Icon icon="bxs:up-arrow" className="text-xs" /> +{stats.subscriptions_last_30.toLocaleString()}
                            </span>
                            Last 30 days subscription
                        </p>
                    </div>
                </div>
                {/* card end */}
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-3 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">
                                    Total Free Users
                                </p>
                                <h6 className="mb-0">{stats.total_free_users.toLocaleString()}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-primary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="fluent:people-20-filled"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                        <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                            <span className="d-inline-flex align-items-center gap-1 text-success-main">
                                <Icon icon="bxs:up-arrow" className="text-xs" /> +{stats.free_users_last_30.toLocaleString()}
                            </span>
                            Last 30 days users
                        </p>
                    </div>
                </div>
                {/* card end */}
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-4 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Income</p>
                                <h6 className="mb-0">AED {stats.total_income.toLocaleString()}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-primary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="solar:wallet-bold"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                        <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                            <span className="d-inline-flex align-items-center gap-1 text-success-main">
                                <Icon icon="bxs:up-arrow" className="text-xs" /> +AED {stats.income_last_30.toLocaleString()}
                            </span>
                            Last 30 days income
                        </p>
                    </div>
                </div>
                {/* card end */}
            </div>

        </div>

    )
}

export default UnitCountOne